<section class="h-100 gradient-custom-2">
    <div class="container py-5 h-100">
        <div class="row d-flex justify-content-center align-items-center h-100">
            <div class="col col-lg-12 col-xl-12">
                <div class="card">
                    <div class="rounded-top text-white d-flex flex-row" style="background-color: #000; height:200px;">
                        <div class="ms-4 mt-5 d-flex flex-column" style="width: 150px;">
                            <img src="{{user.profilePicture}}" alt="Generic placeholder image"
                                class="img-fluid img-thumbnail mt-4 mb-2" style="width: 150px; z-index: 1">

                        </div>
                        <div class="ms-3" style="margin-top: 130px;">
                            <h5>{{user.firstName}} {{user.lastName}}</h5>
                            <p>{{user.location}}</p>
                        </div>
                    </div>
                    <div class="p-4 text-black" style="background-color: #f8f9fa;">
                        <div class="d-flex justify-content-end text-center py-1">
                            <div>
                                <p class="mb-1 h5"><a href="{{user.socialLinks.facebook}}" target="_blank"><span
                                            class="fab fa-facebook-f"></span></a></p>
                                <p class="small text-muted mb-0">Facebook</p>
                            </div>
                            <div class="px-3">
                                <p class="mb-1 h5"><a href="{{user.socialLinks.twitter}}" target="_blank"><span
                                            class="fab fa-twitter"></span></a></p>
                                <p class="small text-muted mb-0">Twitter</p>
                            </div>
                            <div>
                                <p class="mb-1 h5"><a href="{{user.socialLinks.instagram}}" target="_blank"><span
                                            class="fab fa-instagram"></span></a> </p>
                                <p class="small text-muted mb-0">Instagram</p>
                            </div>
                        </div>
                    </div>
                    <div class="card-body p-4 text-black">
                        <div class="mb-5">
                            <p class="lead fw-normal mb-1">About</p>
                            <div class="p-4" style="background-color: #f8f9fa;">
                                {{user.bio}}
                            </div>
                        </div>
                        <div class="mb-5">
                            <p class="lead fw-normal mb-1">Experience</p>
                            <div class="p-4" style="background-color: #f8f9fa;">
                                {{user.experience}}
                            </div>
                        </div>
                        <div class="mb-5">
                            <p class="lead fw-normal mb-1">Education</p>
                            <div class="p-4" style="background-color: #f8f9fa;">
                                {{user.education}}
                            </div>
                        </div>
                        <div class="mb-5">
                            <p class="lead fw-normal mb-1">Awards</p>
                            <div class="p-4" style="background-color: #f8f9fa;">
                                <ul class="list-group">
                                    <li *ngFor="let award of user.awards" class="list-group-item">{{award}}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center mb-4">
                            <p class="lead fw-normal mb-0">Action photos</p>
                        </div>
                        <div class="group-2">
                            <div>
                                <img *ngFor="let img of imageObject; let i = index"
                                    [src]="img.thumbImage || img.posterImage" (click)="showLightbox(i)" />
                            </div>
                        </div>
                        <ng-image-fullscreen-view [images]="imageObject" [imageIndex]="currentIndex" [show]="showFlag"
                            (close)="closeEventHandler()"></ng-image-fullscreen-view>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>